
import Vue from 'vue';
import User from '../../model/User';
import { Prop, Watch, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserModule from '../../store/modules/User';
import store from '../../store';
import Debounce from '../../decorators/debounce';
import LogoUploader from './LogoUploader.vue';
import Integrations from '../Integrations.vue';
import FinanceStuff from '../FinanceStuff.vue';
import AccountSettings from '../AccountSettings.vue';
import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';
import sessionGuard from '@/service/sessionGuard';

const userModule = getModule(UserModule, store);

@Component({
    components: {
        LogoUploader,
        Integrations,
        AccountSettings,
        FinanceStuff,
    }
})
export default class UserPanel extends Vue {
    @Prop({
        required: true
    })
    public user!: User;
    public studioName: string|null = null;
    public avatarFailed = false;
    public menuOpen = false;
    private countdownSeconds = sessionGuard.getRemainingSeconds();
    private countdownInterval: number | null = null;

    playSlideSound() {
        const audio = createInterfaceSound('/sound/slide.wav');
        playInterfaceSound(audio).catch(error => {
            console.log('Audio playback failed:', error);
        });
    }

    openFinanceStuff() {
        this.$root.$emit('openFinanceStuff');
    }

    @Watch('studioName')
    @Debounce(500)
    public studioNameChanged(newName: string) {
        if (newName !== this.user.studioName) {
            userModule.changeStudioName(newName);
        }
    }

    @Watch('user')
    public userChanged() {
        this.avatarFailed = false;
    }

    @Watch('avatarUrl')
    public avatarUrlChanged() {
        this.avatarFailed = false;
    }

    public mounted() {
        this.studioName = this.userStudioName || null;
        this.countdownInterval = window.setInterval(() => {
            this.countdownSeconds = sessionGuard.getRemainingSeconds();
        }, 1000);
    }

    public beforeDestroy() {
        if (this.countdownInterval !== null) {
            clearInterval(this.countdownInterval);
        }
    }

    get logoutCountdown(): string {
        const minutes = Math.floor(this.countdownSeconds / 60);
        const seconds = this.countdownSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    get avatarUrl(): string {
        const defaultUrl = '/img/tempAvatar.jpg';
        const user = this.user;

        if (user.avatarUrl) {
            return user.avatarUrl;
        }

        return defaultUrl;
    }

    get userStudioName() {
        return this.user.studioName;
    }

    get userName(): string {
        const user = this.user;
        if (user.firstName || user.lastName)
            return `${user.firstName || ''} ${user.lastName || ''}`;
        else 
            return 'Ustawienia konta';
    }

    public handleAvatarError() {
        this.avatarFailed = true;
    }

    public logout() {
        userModule.logout();
    }
}
